"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Coord04ExternalArchive() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.3
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: detailsRef,
    isVisible: detailsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const headlineWords = ["Document", "your", "discovery.", "Expand", "the"];
  const italicWord = "cosmos.";
  return;
}